<div fxLayout="row" fxLayoutAlign="center">
  <div fxLayout="column" fxFlex="98%">
    <div fxLayout="row" fxLayoutAlign="end">
      <div fxLayout="column" fxFlex="100%" [style.position]="'relative'">
        <button
          class="link-button close-button"
          (click)="this.dialogRef.close()"
        >
          CLOSE
        </button>
      </div>
    </div>
    <br />
    <mat-dialog-content>
       <app-help-faq-content></app-help-faq-content>
    </mat-dialog-content>
  </div>
</div>
